module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-btn', {
    attrs: {
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.getSims(1)
      }
    }
  }, [_vm._v("Sync SIMS")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.getCalamps()
      }
    }
  }, [_vm._v("Sync CALAMP")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3056d742","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Import.vue
// module id = 740
// module chunks = 1